import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { useTheme } from "../context/ThemeContext";

const CustomDataTable = ({
  data,
  columns,
  filters,
  first,
  rowsPerPage,
  withSort = false,
  onSelectedRowsChange,
  withSelect = false,
  withRadio = false,
  withPagination = true,
  search,
  actions,
  header,
  loading = false,
}) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const { theme } = useTheme();
  const { t } = useTranslation();

  // Handle row selection changes
  const handleSelectionChange = useCallback(
    (e) => {
      setSelectedRows(e.value);
      if (onSelectedRowsChange) {
        onSelectedRowsChange(e.value);
      }
    },
    [onSelectedRowsChange]
  );

  return (
    <div className="custom-data-table">
      {(search || actions) && (
        <div className="flex flex-1 items-center justify-between rounded-lg bg-[#F9FAFB] px-5 pb-4 pt-6 dark:bg-[#1F2937]">
          <div className="flex w-full items-center justify-between text-left rtl:text-right">
            {search}
            <div className="flex space-x-3">{actions}</div>
          </div>
        </div>
      )}

      <DataTable
        first={first ? first : null}
        header={header}
        rows={rowsPerPage ? rowsPerPage : 7}
        value={data}
        loading={loading}
        filters={filters}
        currentPageReportTemplate
        paginator={withPagination}
        rowsPerPageOptions={[5, 7, 10, 25, 50]}
        selection={selectedRows}
        filterDisplay="menu"
        onSelectionChange={withSelect ? handleSelectionChange : undefined}
        selectionMode={withSelect ? (withRadio ? "radiobutton" : "checkbox") : undefined}
        stripedRows
        removableSort={withSort}
        className={`p-datatable-${theme} custom-checkbox-style-${theme} custom-radiobutton-style-${theme}`}
        emptyMessage={t("no_data_available")}
        responsiveLayout="scroll"
      >
        {withSelect && (
          <Column selectionMode={withRadio ? "single" : "multiple"} headerStyle={{ width: "3rem" }} />
        )}

        {columns.map((col, index) => (
          <Column
            key={index}
            field={col.field}
            header={col.name}
            showFilterMenu={false}
            sortable={withSort && col.sortable}
            body={col.body}
            filter={col.filter} // Add this for filtering support
            filterElement={col.filterElement} // Opt
          />
        ))}
      </DataTable>
    </div>
  );
};

export default CustomDataTable;
